import { postRequest } from '@/core';
import { orders } from '@/requests';

export default async function getOrdersByIdsRequest(idList, filter) {
	let url = orders.getMultipleByIdPath();
	let response = await postRequest(url,{}, { idList, searchFilter: { ...filter } });
	return response;
}
